var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homeIndex"},[_c('HomeBanner',{on:{"downFile":_vm.downFile}}),_c('HotGame',{on:{"downFile":_vm.downFile}}),_c('SwiperBanner'),_c('BoxDownloadModal',{ref:"boxDownloadModal",attrs:{"cssType":2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }